module.exports = __webpack_public_path__ + "static/media/cours-saphir.02d1c4c7.png";